(() => {
  function initialize(section) {
    if (section.dataset.lcTeenReady) return;
    section.dataset.lcTeenReady = 'true';
    const navigation = section.querySelector('[data-lc-navigation]');
    const buttons = Array.from(section.querySelectorAll('[data-lc-filter]'));
    const products = Array.from(section.querySelectorAll('[data-lc-product-step]'));
    const note = section.querySelector('[data-lc-extra-note]');
    const count = section.querySelector('[data-lc-result-count]');
    const heading = section.querySelector('[data-lc-selection-heading]');
    const intro = section.querySelector('[data-lc-selection-intro]');
    const why = section.querySelector('[data-lc-selection-why]');
    const grid = section.querySelector('.lc-teen__grid');
    const selection = section.querySelector('.lc-teen__selection');
    const next = section.querySelector('[data-lc-next]');
    const nextWrap = section.querySelector('[data-lc-next-wrap]');
    const nextSteps = {cleanse: 'moisturize', moisturize: 'protect', protect: 'all'};
    const shop = section.querySelector('[data-lc-zone="shop"]');
    let currentStep = 'all';
    function selectStep(step) {
      const selected = buttons.find(button => button.dataset.lcStep === step);
      if (!selected) return;
      currentStep = step;
      let visible = 0;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
      products.forEach(product => {
        const matches = step === 'all' || product.dataset.lcProductStep === step;
        product.hidden = !matches;
        if (matches) visible += 1;
      });
      if (heading) heading.textContent = selected.dataset.heading;
      if (intro) intro.textContent = selected.dataset.intro;
      if (why) why.textContent = selected.dataset.why;
      if (selection) {selection.dataset.lcStep = step;selection.hidden = step === 'all';}
      if (grid) grid.dataset.lcVisibleCount = String(visible);
      if (note) note.hidden = step !== 'extra';
      if (count) count.textContent = count.dataset.countLabel.replace('[count]', String(visible));
      if (nextWrap) nextWrap.hidden = !nextSteps[step];
      if (next) next.textContent = selected.dataset.nextLabel || '';
      section.querySelectorAll('[data-lc-routine-slot]').forEach(slot => {
        if (slot.dataset.lcRoutineSlot === step) slot.setAttribute('aria-current', 'step');
        else slot.removeAttribute('aria-current');
      });
    }
    buttons.forEach(button => button.addEventListener('click', () => selectStep(button.dataset.lcStep)));
    if (next) next.addEventListener('click', () => {
      const step = nextSteps[currentStep];
      selectStep(step);
      if (shop) shop.scrollIntoView({block: 'start', behavior: 'instant'});
      const selected = buttons.find(button => button.dataset.lcStep === step);
      if (selected) selected.focus({preventScroll: true});
    });
    const routinePanel = section.querySelector('[data-lc-routine]');
    const routineSteps = ['cleanse', 'moisturize', 'protect'];
    const routinePicks = new Map();
    const routineSlots = Array.from(section.querySelectorAll('[data-lc-routine-slot]'));
    const pickButtons = Array.from(section.querySelectorAll('[data-lc-routine-pick]'));
    const startLinks = Array.from(section.querySelectorAll('[data-lc-build-start]'));
    const routineForm = section.querySelector('[data-lc-routine-form]');
    const addRoutine = section.querySelector('[data-lc-add-routine]');
    const routineError = section.querySelector('[data-lc-routine-error]');
    const cartLink = section.querySelector('[data-lc-routine-cart-link]');
    let building = false;
    let submitting = false;
    const routineMoney = new Intl.NumberFormat(routinePanel.dataset.locale || 'en', {style: 'currency', currency: routinePanel.dataset.currency || 'CAD', currencyDisplay: 'code'});

    function updateRoutine() {
      let total = 0;
      routinePanel.dataset.count = String(routinePicks.size);
      section.querySelector('[data-lc-routine-close]').disabled = submitting;
      section.querySelector('[data-lc-routine-reset]').disabled = submitting;
      routineSlots.forEach(slot => {
        slot.disabled = submitting;
        const pick = routinePicks.get(slot.dataset.lcRoutineSlot);
        const image = slot.querySelector('[data-lc-slot-image]');
        const sculpture = slot.querySelector('.lc-teen-icon');
        slot.dataset.filled = String(Boolean(pick));
        slot.querySelector('[data-lc-slot-product]').textContent = pick ? pick.title : slot.dataset.emptyLabel;
        slot.setAttribute('aria-label', slot.dataset.label + ': ' + (pick ? pick.title : slot.dataset.emptyLabel));
        image.hidden = !pick;
        sculpture.hidden = Boolean(pick);
        if (pick) {
          if (image.getAttribute('src') !== pick.image) image.src = pick.image;
          total += pick.price;
        } else image.removeAttribute('src');
        const variant = routineForm.querySelector('[data-lc-routine-variant="' + slot.dataset.lcRoutineSlot + '"]');
        const quantity = routineForm.querySelector('[data-lc-routine-quantity="' + slot.dataset.lcRoutineSlot + '"]');
        variant.value = pick ? pick.variant : '';
        variant.disabled = !pick;
        quantity.disabled = !pick;
      });
      section.querySelector('[data-lc-routine-progress]').textContent = routinePanel.dataset.progressLabel.replace('[count]', String(routinePicks.size));
      section.querySelector('[data-lc-routine-total]').textContent = routineMoney.format(total / 100);
      section.querySelector('[data-lc-routine-total-wrap]').hidden = routinePicks.size === 0;
      section.querySelector('[data-lc-routine-reset]').hidden = routinePicks.size === 0;
      addRoutine.disabled = routinePicks.size !== 3 || submitting;
      addRoutine.hidden = routinePicks.size !== 3;
      addRoutine.textContent = submitting ? routinePanel.dataset.addingLabel : routinePanel.dataset.cartLabel;
      pickButtons.forEach(button => {
        const card = button.closest('[data-lc-product-step]');
        const chosen = routinePicks.get(card.dataset.lcProductStep)?.variant === card.dataset.lcVariant;
        button.setAttribute('aria-pressed', String(chosen));
        button.textContent = chosen ? button.dataset.removeLabel : button.dataset.pickLabel;
        button.disabled = submitting;
        button.setAttribute('aria-label', button.textContent + ': ' + card.dataset.lcProductTitle);
        card.dataset.lcChosen = String(chosen);
      });
      const notes = section.querySelector('[data-lc-routine-notes]');
      const list = section.querySelector('[data-lc-routine-notes-list]');
      notes.hidden = routinePicks.size === 0;
      list.replaceChildren();
      routineSteps.forEach(step => {
        const pick = routinePicks.get(step);
        if (!pick) return;
        const item = document.createElement('li');
        const link = document.createElement('a');
        const copy = document.createElement('p');
        link.href = pick.url;
        link.textContent = pick.title + (pick.size ? ' · ' + pick.size : '');
        copy.textContent = pick.advice;
        item.append(link, copy);
        list.append(item);
      });
    }

    function setBuilding(value) {
      building = value;
      section.dataset.lcBuilding = String(value);
      routinePanel.hidden = !value;
      startLinks.forEach(link => link.setAttribute('aria-expanded', String(value)));
      pickButtons.forEach(button => {
        button.hidden = !value;
        button.closest('[data-lc-product-step]').querySelector('[data-lc-product-link]').hidden = value;
      });
      updateRoutine();
    }

    function focusRoutineStep(step) {
      selectStep(step);
      if (shop) shop.scrollIntoView({block: 'start', behavior: 'instant'});
      const focusTarget = routinePicks.size === 3 && step === 'all' ? addRoutine : buttons.find(button => button.dataset.lcStep === step);
      if (focusTarget) focusTarget.focus({preventScroll: true});
    }

    function openRoutine() {
      if (submitting) return;
      setBuilding(true);
      focusRoutineStep(routineSteps.find(step => !routinePicks.has(step)) || 'all');
    }

    routineSlots.forEach(slot => slot.addEventListener('click', () => focusRoutineStep(slot.dataset.lcRoutineSlot)));
    section.querySelector('[data-lc-routine-close]').addEventListener('click', () => {
      setBuilding(false);
      selectStep('all');
      buttons.find(button => button.dataset.lcStep === 'all').focus({preventScroll: true});
    });
    section.querySelector('[data-lc-routine-reset]').addEventListener('click', () => {
      routinePicks.clear();
      routineError.hidden = true;
      cartLink.hidden = true;
      updateRoutine();
      focusRoutineStep('cleanse');
    });
    pickButtons.forEach(button => button.addEventListener('click', () => {
      if (submitting) return;
      const card = button.closest('[data-lc-product-step]');
      const step = card.dataset.lcProductStep;
      if (!routineSteps.includes(step)) return;
      const chosen = routinePicks.get(step)?.variant === card.dataset.lcVariant;
      if (chosen) routinePicks.delete(step);
      else {
        const productImage = card.querySelector('.lc-teen__image > img');
        const price = Number(card.dataset.lcPrice);
        if (!Number.isSafeInteger(price) || price < 0 || !/^\d+$/.test(card.dataset.lcVariant)) return;
        routinePicks.set(step, {variant: card.dataset.lcVariant, price, title: card.dataset.lcProductTitle, size: card.dataset.lcVariantTitle === 'Default Title' ? '' : card.dataset.lcVariantTitle, url: card.dataset.lcProductUrl, advice: card.dataset.lcProductAdvice, image: productImage.currentSrc || productImage.src});
      }
      routineError.hidden = true;
      cartLink.hidden = true;
      updateRoutine();
      focusRoutineStep(chosen ? step : routineSteps.find(nextStep => !routinePicks.has(nextStep)) || 'all');
    }));
    routineForm.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting || routinePicks.size !== 3) return;
      submitting = true;
      routineError.hidden = true;
      cartLink.hidden = true;
      routineForm.setAttribute('aria-busy', 'true');
      updateRoutine();
      try {
        const response = await fetch(routineForm.dataset.cartAdd, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: routineSteps.map(step => ({id: Number(routinePicks.get(step).variant), quantity: 1}))})});
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.items) || result.items.length !== 3) throw new Error('routine-cart');
        window.location.assign(routineForm.dataset.cartUrl);
      } catch {
        submitting = false;
        routineForm.removeAttribute('aria-busy');
        routineError.textContent = routinePanel.dataset.errorLabel;
        routineError.hidden = false;
        cartLink.hidden = false;
        updateRoutine();
        routineError.setAttribute('tabindex', '-1');
        routineError.focus({preventScroll: true});
      }
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      submitting = false;
      routineForm.removeAttribute('aria-busy');
      updateRoutine();
    });
    if (!routineSteps.every(step => pickButtons.some(button => button.closest('[data-lc-product-step]').dataset.lcProductStep === step))) startLinks.forEach(link => {link.hidden = true;});

    selectStep('all');
    if (navigation) navigation.hidden = false;

    section.querySelectorAll('a[href^="#"]').forEach(link => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target || !section.contains(target)) return;
      link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (link.hasAttribute('data-lc-build-start')) {openRoutine();return;}
        if (link.dataset.lcShopStep) selectStep(link.dataset.lcShopStep);
        target.scrollIntoView({block: 'start', behavior: 'instant'});
        const title = target.querySelector('h2');
        if (title) {
          title.setAttribute('tabindex', '-1');
          title.focus({preventScroll: true});
        }
      });
    });

    const times = Array.from(section.querySelectorAll('[data-lc-time]'));
    const panels = Array.from(section.querySelectorAll('[data-lc-routine-panel]'));
    function selectTime(time) {
      times.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lcTime === time)));
      panels.forEach(panel => {panel.hidden = panel.dataset.lcRoutinePanel !== time;});
    }
    times.forEach(button => button.addEventListener('click', () => selectTime(button.dataset.lcTime)));
    selectTime('morning');
    const timeSwitch = section.querySelector('[data-lc-time-switch]');
    if (timeSwitch) timeSwitch.hidden = false;

    const zoneLinks = Array.from(section.querySelectorAll('[data-lc-zone-link]'));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const active = entries.find(entry => entry.isIntersecting);
        if (!active) return;
        zoneLinks.forEach(link => {
          if (link.dataset.lcZoneLink === active.target.dataset.lcZone) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }, {rootMargin: '-72px 0px -55% 0px', threshold: 0});
      section.querySelectorAll('[data-lc-zone]').forEach(zone => observer.observe(zone));
    }
  }
  document.querySelectorAll('[data-lc-teen]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-lc-teen]').forEach(initialize);
  });
})();
